import { autoAnimatePlugin } from '@formkit/auto-animate/vue';
import { createApp } from 'vue';
import VueSignaturePad from 'vue-signature-pad';
import App from './App.vue';
import { initChunkLoadRecovery } from './core/helpers/chunk-load-recovery.helper';
import keycloak from './core/helpers/keycloak.helper';
import { initSentry } from './core/helpers/sentry.helper';
import './core/validation/yup-string-length';
import appGlobals from './core/plugins/app-globals';
import router from './core/router';
import directivesService from './core/services/directives.service';
import store from './core/store';
import i18n from './i18n';

const app = createApp(App);

// Register our error handler before Sentry attaches. Sentry's Vue error handler
// re-throws synchronously when no prior `app.config.errorHandler` exists, which
// aborts Vue's job flush mid-render. Installing ours first makes Sentry take its
// non-throwing path and wrap our handler instead.
initChunkLoadRecovery(app);
initSentry(app, router);

app.use(keycloak);
app.use(store);
app.use(router);
app.use(i18n);
app.use(VueSignaturePad);
app.use(autoAnimatePlugin);
app.use(appGlobals);

directivesService.setupDirectives(app);

app.mount('#app');
